import React from 'react';

export const TenantLogoIcon = ({size, logoIconUrl, tenantAlias = 'move'}) => {
    if(logoIconUrl == null) {
        return (<></>);
    }

    const handleImageError = (event) => {
      event.target.src = `https://storage.googleapis.com/mk-move-repository/white-label/${tenantAlias}/images/tenant-alias.png`;
    };

    return (
        <img
            src={`https://storage.googleapis.com/mk-move-repository/white-label/${logoIconUrl}/images/tenant-alias.png`}
            alt="logo"
            className="thunder_icon" style={{ width: size + 'px' }}
            onError={handleImageError}
        />
    );
};
